module.exports = __webpack_public_path__ + "img/solution26.82307a2a.png";